// extracted by mini-css-extract-plugin
export default {"cls1":"SJdxQLkBQKFpUmrq9paw","cls2":"SPKtfeHFXOv79p3YJycg SJdxQLkBQKFpUmrq9paw"};